import React from 'react';
import { Text } from '@common/components';
import { ColorsType } from '@common/tokens';

export type KnownRequestState =
  | 'OPEN'
  | 'ON_HOLD'
  | 'FILLED'
  | 'CANCELLED'
  | 'PENDING'
  | 'REJECTED_BY_APPROVER';

export const COLOR_STYLE_MAP = {
  OPEN: 'grass',
  ON_HOLD: 'sun-darker',
  FILLED: 'elm',
  CANCELLED: 'coral',
  PENDING: 'midnight-darkest',
  REJECTED_BY_APPROVER: 'coral',
} as const satisfies Record<KnownRequestState, string>;

type LegacyColor = (typeof COLOR_STYLE_MAP)[KnownRequestState];

const COLOR_LEGACY_TO_TOKEN: Record<LegacyColor, ColorsType> = {
  grass: 'grass',
  'sun-darker': 'sunDarker',
  elm: 'elm',
  coral: 'coral',
  'midnight-darkest': 'textDefault',
};

const TEXT_COLOR_MAP: Record<KnownRequestState, ColorsType> = {
  OPEN: COLOR_LEGACY_TO_TOKEN[COLOR_STYLE_MAP.OPEN],
  ON_HOLD: COLOR_LEGACY_TO_TOKEN[COLOR_STYLE_MAP.ON_HOLD],
  FILLED: COLOR_LEGACY_TO_TOKEN[COLOR_STYLE_MAP.FILLED],
  CANCELLED: COLOR_LEGACY_TO_TOKEN[COLOR_STYLE_MAP.CANCELLED],
  PENDING: COLOR_LEGACY_TO_TOKEN[COLOR_STYLE_MAP.PENDING],
  REJECTED_BY_APPROVER:
    COLOR_LEGACY_TO_TOKEN[COLOR_STYLE_MAP.REJECTED_BY_APPROVER],
};

export const LABEL_OVERWRITE: Record<KnownRequestState, string> = {
  OPEN: 'Open',
  ON_HOLD: 'On Hold',
  FILLED: 'Filled',
  CANCELLED: 'Cancelled',
  PENDING: 'Pending',
  REJECTED_BY_APPROVER: 'Not Approved',
};

const isKnownRequestState = (value: string): value is KnownRequestState =>
  value in TEXT_COLOR_MAP;

const resolveColor = (state: string): ColorsType =>
  isKnownRequestState(state) ? TEXT_COLOR_MAP[state] : 'textDefault';

const resolveLabel = (state: string): string =>
  isKnownRequestState(state) ? LABEL_OVERWRITE[state] : state;

export const StaffingRequestState = ({ state }: { state: string }) => (
  <Text weight="bolder" color={resolveColor(state)}>
    {resolveLabel(state)}
  </Text>
);
